import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { ParamContext } from '../service/param.context';
import { ListModel } from '../list-builder/model/list.model';
import { ListType } from '../list-builder/model/list-type.model';
import { ListService } from './service/list.service';
import { AlertService } from '../alert/alert.service';
import { DateHelperService } from '../service/date.helper.service';
import { JhiEventManager } from '../core-utils';
import { SubscriptionsManager } from '../util/subscriptions-manager';

@Component({
    template: ''
})
export abstract class ListMetadataComponent implements OnInit, OnDestroy {

    listTypes: ListType[];
    @Input() listId: number;
    model: ListModel = {};

    isLoading: boolean;
    selectedDate: NgbDate;
    subscriptionManager = new SubscriptionsManager();

    constructor(public modal: NgbActiveModal,
                public eventManager: JhiEventManager,
                public paramContext: ParamContext,
                public alertService: AlertService,
                public listService: ListService,
                public dateHelperService: DateHelperService) {
        if (!this.paramContext.cropName) {
            this.paramContext.readParams();
        }
    }

    ngOnDestroy(): void {
        this.subscriptionManager.unsubscribeAll();
    }

    ngOnInit(): void {
        this.subscriptionManager.add = this.listService.getListTypes().subscribe((listTypes) => this.listTypes = listTypes);
        this.subscriptionManager.add = this.listService.getById(this.listId).subscribe((listModel) => {
            this.model = listModel;
            this.selectedDate =  this.dateHelperService.convertFormattedDateStringToNgbDate(this.model.creationDate, 'yyyy-mm-dd');
        });
    }

    isFormValid(f) {
        return f.form.valid && !this.isLoading;
    }

    closeModal() {
        this.modal.dismiss();
    }

    save() {
        this.isLoading = true;
        this.model.creationDate = `${this.selectedDate.year}-${this.selectedDate.month}-${this.selectedDate.day}`;
        this.subscriptionManager.add = this.listService.updateListMetadata(this.listId, this.model)
            .subscribe(
                (res) => this.onSaveSuccess(),
                () => this.isLoading = false);
    }

    onSaveSuccess() {
        this.isLoading = false;
        this.alertService.success('edit-list-metadata.success');
        this.eventManager.broadcast({ name: 'listMetadataUpdated', content: this.listId });
        this.modal.close();
    }

}
